import Pause from '@/api/pause'
import loading from '../helpers/loading'

const wrapLoading = ({ commit }, action) => {
  commit('changeLoading', { isLoading: true })
  return action()
    .then(({ data }) => {
      commit('changeLoading', { isLoading: false })
      return data
    })
    .catch(error => {
      commit('changeLoading', { isLoading: false })
      throw error
    })
}

export default {
  namespaced: true,
  state: {
    ...loading.state
  },
  getters: {
    ...loading.getters
  },
  mutations: {
    ...loading.mutations
  },
  actions: {
    create: store => wrapLoading(store, () => Pause.create())
      .then(user => store.commit('skiliko/session/currentUser', { user: user }, { root: true })),
    cancel: store => wrapLoading(store, () => Pause.cancel())
      .then(user => store.commit('skiliko/session/currentUser', { user: user }, { root: true }))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/pauses/index.js